"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallationValidator = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const fs = require("fs");
const path = require("path");
const os = require("os");
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
const IInstallationValidator_1 = require("./IInstallationValidator");
class InstallationValidator extends IInstallationValidator_1.IInstallationValidator {
    validateDotnetInstall(install, dotnetPath, isDotnetFolder = false, failOnErr = true) {
        const dotnetValidationFailed = `Validation of .dotnet installation for version ${JSON.stringify(install)} failed:`;
        const folder = path.dirname(dotnetPath);
        if (!isDotnetFolder) {
            this.assertOrThrowError(failOnErr, fs.existsSync(folder), `${dotnetValidationFailed} Expected installation folder ${folder} does not exist.`, install, dotnetPath);
            this.assertOrThrowError(failOnErr, fs.existsSync(dotnetPath), `${dotnetValidationFailed} Expected executable does not exist at "${dotnetPath}"`, install, dotnetPath);
            this.assertOrThrowError(failOnErr, fs.lstatSync(dotnetPath).isFile(), `${dotnetValidationFailed} Expected executable file exists but is not a file: "${dotnetPath}"`, install, dotnetPath);
        }
        else {
            this.assertOrThrowError(failOnErr, fs.existsSync(folder), `${dotnetValidationFailed} Expected dotnet folder ${dotnetPath} does not exist.`, install, dotnetPath);
            try {
                this.assertOrThrowError(failOnErr, fs.readdirSync(folder).length !== 0, `${dotnetValidationFailed} The dotnet folder is empty "${dotnetPath}"`, install, dotnetPath);
            }
            catch (error) // fs.readdirsync throws ENOENT so we need to recall the function
             {
                this.assertOrThrowError(failOnErr, false, `${dotnetValidationFailed} The dotnet file dne "${dotnetPath}"`, install, dotnetPath);
            }
        }
        this.eventStream.post(new EventStreamEvents_1.DotnetInstallationValidated(install));
    }
    assertOrThrowError(failOnErr, passedValidation, message, install, dotnetPath) {
        var _a;
        if (!passedValidation && failOnErr) {
            this.eventStream.post(new EventStreamEvents_1.DotnetInstallationValidationError(new Error(message), install, dotnetPath));
            throw new EventStreamEvents_1.EventBasedError('DotnetInstallationValidationError', message);
        }
        if (os.platform() === 'darwin') {
            message = `Did you close the .NET Installer, cancel the installation, or refuse the password prompt? If you want to install the .NET SDK, please try again. If you are facing an error, please report it at https://github.com/dotnet/vscode-dotnet-runtime/issues.
${message}`;
        }
        if (!passedValidation && !failOnErr) {
            (_a = this.eventStream) === null || _a === void 0 ? void 0 : _a.post(new EventStreamEvents_1.DotnetInstallationValidationMissed(new Error(message), message));
        }
    }
}
exports.InstallationValidator = InstallationValidator;
//# sourceMappingURL=InstallationValidator.js.map